export default "__VITE_ASSET__Xg5lC9oo__"